var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBupa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1558 63.288C58.3106 63.288 64.9214 56.6772 64.9214 48.5223C64.9214 40.3675 58.3106 33.7567 50.1558 33.7567C42.0009 33.7567 35.3901 40.3675 35.3901 48.5223C35.3901 56.6772 42.0009 63.288 50.1558 63.288Z",
    fill: "#DDE2E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2652 48.125L34.9999 61.5059L12.8241 37.3144C7.81585 31.85 8.18554 23.3483 13.6488 18.34C19.1132 13.3317 27.6149 13.7014 32.6232 19.1647L34.9999 21.758L37.3766 19.1647C42.3849 13.7014 50.8866 13.3317 56.351 18.34C61.8143 23.3483 62.184 31.85 57.1757 37.3144L51.4062 43.6078",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.25 43.75C61.2544 43.6581 50.8594 43.75 50.8594 43.75L46.4844 35L40.4688 47.0312L35 35L30.625 44.2969H25.1562",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2619 34.1108C12.7433 30.2728 13.0026 24.2998 16.8416 20.7812",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBupa);
export default __webpack_public_path__ + "static/media/BUPA.a2a78e89ce2c40e99566fd44610ca6fd.svg";
export { ForwardRef as ReactComponent };